module.exports = __webpack_public_path__ + "static/media/pequeno_prazer_8.d0b0edc3.jpg";